import { Link } from 'react-router-dom'
import { useI18n } from '../lib/i18n'

export function Footer() {
  const { t } = useI18n()
  return (
    <footer className="border-t border-rule mt-24">
      <div className="max-w-[1240px] mx-auto px-6 lg:px-10 py-14 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-4">
          <div className="flex items-center gap-3">
            <img src="/x_logo_white.png" alt="XLAB" className="h-4 w-auto opacity-90" />
            <span className="w-px h-[22px] bg-rule" aria-hidden="true" />
            <span className="flex items-center font-display font-extrabold text-[19px] leading-none text-ink">
              Show
              <img src="/x_symbol_white.png" alt="✕" className="h-[0.6em] ml-1.5 w-auto" />
            </span>
          </div>
          <p className="copy mt-6 max-w-md text-sm">{t('footer.tagline')}</p>
          <p className="mt-4 max-w-md text-xs text-muted">{t('footer.brand-note')}</p>
          <p className="mt-2 max-w-md text-xs text-muted font-mono">{t('footer.region')}</p>
        </div>
        <div className="md:col-span-2">
          <div className="section-label mb-4">{t('footer.product')}</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/try-it" className="hover:text-accent-deep">{t('nav.try-it')}</Link></li>
            <li><Link to="/status" className="hover:text-accent-deep">{t('nav.status')}</Link></li>
            <li><Link to="/downloads" className="hover:text-accent-deep">{t('nav.downloads')}</Link></li>
            <li><Link to="/docs" className="hover:text-accent-deep">{t('nav.docs')}</Link></li>
          </ul>
        </div>
        <div className="md:col-span-3">
          <div className="section-label mb-4">{t('footer.resources')}</div>
          <ul className="space-y-2 text-sm">
            <li>
              <a href="https://github.com/xlab/showx" target="_blank" rel="noreferrer" className="hover:text-accent-deep">
                {t('footer.github')}
              </a>
            </li>
            <li>
              <a
                href="https://github.com/xlab/showx/blob/main/docs/dev"
                target="_blank"
                rel="noreferrer"
                className="hover:text-accent-deep"
              >
                {t('footer.devdocs')}
              </a>
            </li>
            <li>
              <a
                href="https://github.com/xlab/xlab-strategy/blob/main/docs/showx_mvp_scope.md"
                target="_blank"
                rel="noreferrer"
                className="hover:text-accent-deep"
              >
                {t('footer.strategy')}
              </a>
            </li>
          </ul>
        </div>
        <div className="md:col-span-3">
          <div className="section-label mb-4">{t('footer.contact')}</div>
          <ul className="space-y-2 text-sm">
            <li className="text-muted">XLAB — Praha</li>
            <li>
              <a
                href="mailto:hello@xlabproject.net?subject=ShowX%20dev%20preview%20cohort"
                className="hover:text-accent-deep"
              >
                {t('footer.preview')}
              </a>
            </li>
            <li>
              <a href="mailto:hello@xlabproject.net?subject=ShowX%20dev%20bug" className="hover:text-accent-deep">
                {t('footer.bugs')}
              </a>
            </li>
            <li>
              <a href="mailto:hello@xlabproject.net?subject=ShowX%20support" className="hover:text-accent-deep">
                {t('footer.support')}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-rule">
        <div className="max-w-[1240px] mx-auto px-6 lg:px-10 py-5 flex flex-col md:flex-row justify-between items-start md:items-center gap-3 text-[11px] tracking-[0.1em] text-muted font-mono">
          <span>{t('footer.copy')}</span>
          <img src="/x_logo_white.png" alt="XLAB" className="h-3 w-auto opacity-70 hidden md:block" />
          <a href="https://xlabproject.net" className="hover:text-ink transition-colors">
            součást rodiny → xlabproject.net
          </a>
        </div>
      </div>
    </footer>
  )
}
